import React from 'react'
import styled from 'styled-components'
import { Colors, Fonts, FontWeights, INTEGRAL_SUPPORT_URL } from '../constants'
import { Help } from './icons'

export function HelpButton() {
  return (
    <Button target="_blank" href={INTEGRAL_SUPPORT_URL}>
      <HelpIcon />
      <ButtonText>Help</ButtonText>
    </Button>
  )
}

const Button = styled.a`
  text-decoration: none;
  font-family: ${Fonts.Header};
  font-weight: ${FontWeights.Semibold};
  color: ${Colors.White};
  background-color: #1f73b7;
  padding: 12px 20px;
  border-radius: 30px;
  z-index: 1000;
  position: fixed;
  right: 10px;
  bottom: 65px;
`
const ButtonText = styled.span`
  vertical-align: middle;
  padding-left: 6px;
`

const HelpIcon = styled(Help)`
  vertical-align: middle;
  font-size: 20px;
`
